import { render, staticRenderFns } from "./PaymentsNotification.vue?vue&type=template&id=457ff8b5"
import script from "./PaymentsNotification.vue?vue&type=script&lang=js"
export * from "./PaymentsNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports